import { render } from "./AddVpnUser.vue?vue&type=template&id=71979e62&scoped=true"
import script from "./AddVpnUser.vue?vue&type=script&lang=js"
export * from "./AddVpnUser.vue?vue&type=script&lang=js"

import "./AddVpnUser.vue?vue&type=style&index=0&id=71979e62&scoped=true&lang=less"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.18.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71979e62"]])

export default __exports__